var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderPrivateOpened(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3759 4.21204C12.8734 4.69354 12.4117 5.39579 11.7194 5.39579H2.66699C2.11471 5.39579 1.66699 4.94808 1.66699 4.39579V3.74496C1.66699 2.32163 2.82199 1.16663 4.24533 1.16663H5.59866C6.54949 1.16663 6.84699 1.47579 7.22616 1.98329L8.04283 3.06829C8.22366 3.30746 8.24699 3.33663 8.58533 3.33663H10.2128C11.0529 3.33663 11.8158 3.66989 12.3759 4.21204Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3254 7.26736C13.3235 6.7164 12.8763 6.27074 12.3254 6.27075L2.66698 6.27088C2.1147 6.27089 1.66699 6.7186 1.66699 7.27088V9.71256C1.66699 11.4334 3.06699 12.8334 4.78783 12.8334H10.2128C11.9337 12.8334 13.3337 11.4334 13.3337 9.71256L13.3254 7.26736ZM8.09992 9.13339C8.26785 8.95451 8.4999 8.66478 8.4999 8.40006C8.4999 7.84777 8.05221 7.40006 7.49995 7.40006C6.94769 7.40006 6.5 7.84777 6.5 8.40006C6.5 8.66478 6.73205 8.95451 6.89998 9.13339C6.89998 9.45741 6.65935 10.6427 6.5514 11.158C6.52527 11.2828 6.62043 11.4001 6.74792 11.4001H7.50005H8.25608C8.38229 11.4001 8.47715 11.2853 8.45295 11.1614C8.35861 10.6787 8.15099 9.59304 8.09992 9.13339Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderPrivateOpened);
export default __webpack_public_path__ + "static/media/folderPrivateOpened.bd152851693e8df9f868d4e27cd41a2a.svg";
export { ForwardRef as ReactComponent };